module.exports = __webpack_public_path__ + "img/icone_usuario.70bb2d38.svg";